var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { convertModelToFormData } from '../../common/helpers/form-helpers';
import { monteurApi } from '../common/monteur-api';
import { signalRService } from '../common/signalR-service';
import { DocumentProcessingStatus } from './enums/document-processing-status';
import { DocumentUploadingStatus } from './enums/document-uploading-status';
import { setDocumentUploading, setNewDocumentCount } from './machine-documentSlice';
export var machineDocumentsApi = monteurApi
    .enhanceEndpoints({
    addTagTypes: [
        'MachineDocuments',
        'MachineDocument',
        'MachineDocumentsWithGTIN',
        'MatchingMachineDocuments',
        'NewMachineDocuments',
        'NewMachineDocumentsCount',
        'ArchivedMachineDocuments'
    ]
})
    .injectEndpoints({
    endpoints: function (builder) { return ({
        createMachineDocument: builder.mutation({
            query: function (document) { return ({
                url: 'MachineDocument/create',
                method: 'POST',
                body: convertModelToFormData(document)
            }); },
            invalidatesTags: [
                'MachineDocuments',
                'MachineDocument',
                'NewMachineDocuments',
                'NewMachineDocumentsCount',
                'ArchivedMachineDocuments'
            ],
            onQueryStarted: function (_1, _a) {
                return __awaiter(this, arguments, void 0, function (_, _b) {
                    var error_1;
                    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _c.trys.push([0, 2, , 3]);
                                dispatch(setDocumentUploading(DocumentUploadingStatus.Uploading));
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                if (_c.sent()) {
                                    dispatch(setDocumentUploading(DocumentUploadingStatus.Uploaded));
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                error_1 = _c.sent();
                                dispatch(setDocumentUploading(DocumentUploadingStatus.Error));
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        createMachineDocumentByGTIN: builder.mutation({
            query: function (document) { return ({
                url: 'MachineDocument/create-by-gtin',
                method: 'POST',
                body: document
            }); },
            invalidatesTags: [
                'MachineDocuments',
                'MachineDocument',
                'NewMachineDocuments',
                'NewMachineDocumentsCount',
                'ArchivedMachineDocuments'
            ],
            onQueryStarted: function (_1, _a) {
                return __awaiter(this, arguments, void 0, function (_, _b) {
                    var error_2;
                    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _c.trys.push([0, 2, , 3]);
                                dispatch(setDocumentUploading(DocumentUploadingStatus.Uploading));
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                if (_c.sent()) {
                                    dispatch(setDocumentUploading(DocumentUploadingStatus.Uploaded));
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                error_2 = _c.sent();
                                dispatch(setDocumentUploading(DocumentUploadingStatus.Error));
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        getPaginatedMachineDocuments: builder.query({
            query: function (machine) { return ({
                url: "MachineDocument/get-paginated",
                method: 'POST',
                body: machine
            }); },
            providesTags: ['MachineDocuments'],
            onCacheEntryAdded: function (_1, _a) {
                return __awaiter(this, arguments, void 0, function (_, _b) {
                    var cacheDataLoaded = _b.cacheDataLoaded, cacheEntryRemoved = _b.cacheEntryRemoved, updateCachedData = _b.updateCachedData;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, cacheDataLoaded];
                            case 1:
                                _c.sent();
                                return [4 /*yield*/, signalRService.initializeConnection()];
                            case 2:
                                _c.sent();
                                signalRService.subscribeToEvent('ReceiveKnowledgeBaseNotification', function (items) {
                                    updateCachedData(function (currentData) {
                                        items.forEach(function (item) {
                                            var document = currentData.items.find(function (document) { return document.id === item.documentId; });
                                            if (document) {
                                                var kbAdded = item.processingStatus === DocumentProcessingStatus.Success;
                                                document.addedToKnowledgeBase = kbAdded;
                                                document.uploadingStatus = item.uploadingStatus;
                                                document.aiSummary = item.aiSummary;
                                                document.title = item.title;
                                                document.processingStatus = item.processingStatus;
                                            }
                                        });
                                    });
                                });
                                return [4 /*yield*/, cacheEntryRemoved];
                            case 3:
                                _c.sent();
                                signalRService.unsubscribeFromEvent('ReceiveKnowledgeBaseNotification');
                                return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        getNewPaginatedMachineDocuments: builder.query({
            query: function (machine) { return ({
                url: "MachineDocument/get-new-paginated",
                method: 'POST',
                body: machine
            }); },
            providesTags: ['NewMachineDocuments'],
            onQueryStarted: function (arg_1, _a) {
                return __awaiter(this, arguments, void 0, function (arg, _b) {
                    var data;
                    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, queryFulfilled];
                            case 1:
                                data = (_c.sent()).data;
                                if (data.totalCount &&
                                    arg.fileName === '' &&
                                    arg.machineModels.length === 0 &&
                                    arg.page === 1) {
                                    dispatch(setNewDocumentCount(data.totalCount));
                                }
                                return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        getNewMachineDocumentsCount: builder.query({
            query: function () { return ({
                url: "MachineDocument/get-new-count"
            }); },
            providesTags: ['NewMachineDocumentsCount'],
            onQueryStarted: function (_1, _a) {
                return __awaiter(this, arguments, void 0, function (_, _b) {
                    var data;
                    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, queryFulfilled];
                            case 1:
                                data = (_c.sent()).data;
                                dispatch(setNewDocumentCount(data));
                                return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        deleteMachineDocument: builder.mutation({
            query: function (document) { return ({
                url: 'MachineDocument/delete',
                method: 'POST',
                body: document
            }); },
            invalidatesTags: [
                'MachineDocuments',
                'MachineDocument',
                'NewMachineDocuments',
                'NewMachineDocumentsCount',
                'ArchivedMachineDocuments'
            ]
        }),
        getMachineDocument: builder.query({
            query: function (id) { return ({
                url: "MachineDocument/get-by-id?id=".concat(id)
            }); },
            providesTags: ['MachineDocument']
        }),
        updateMachineDocument: builder.mutation({
            query: function (document) { return ({
                url: 'MachineDocument/update',
                method: 'POST',
                body: document
            }); },
            invalidatesTags: [
                'MachineDocument',
                'MachineDocuments',
                'NewMachineDocuments',
                'NewMachineDocumentsCount',
                'ArchivedMachineDocuments'
            ]
        }),
        approveMachineDocument: builder.mutation({
            query: function (document) { return ({
                url: 'MachineDocument/approve',
                method: 'POST',
                body: document
            }); },
            invalidatesTags: [
                'MachineDocument',
                'MachineDocuments',
                'NewMachineDocuments',
                'NewMachineDocumentsCount',
                'ArchivedMachineDocuments'
            ]
        }),
        archiveMachineDocument: builder.mutation({
            query: function (document) { return ({
                url: 'MachineDocument/archive',
                method: 'POST',
                body: document
            }); },
            invalidatesTags: [
                'MachineDocument',
                'MachineDocuments',
                'NewMachineDocuments',
                'NewMachineDocumentsCount',
                'ArchivedMachineDocuments'
            ]
        }),
        getMachineDocumentListByIds: builder.query({
            query: function (ids) { return ({
                url: 'MachineDocument/get-list-by-id',
                method: 'POST',
                body: ids
            }); },
            providesTags: ['MachineDocuments']
        }),
        getMachineDocumentListByMachineId: builder.mutation({
            query: function (id) { return ({
                url: "MachineDocument/get-list-by-machine-id?machineId=".concat(id),
                method: 'GET'
            }); }
        }),
        retryDocumentsProcessing: builder.mutation({
            query: function () { return ({
                url: 'MachineDocument/retry-processing',
                method: 'POST'
            }); }
        }),
        getMatchingPublic: builder.query({
            query: function (query) { return ({
                url: 'MachineDocument/get-matching-public',
                method: 'POST',
                body: query
            }); },
            keepUnusedDataFor: 0,
            providesTags: ['MatchingMachineDocuments']
        }),
        deleteArchiveMachineDocuments: builder.mutation({
            query: function (ids) { return ({
                url: 'Machine/delete-archive-documents',
                method: 'POST',
                body: ids
            }); },
            invalidatesTags: [
                'MachineDocuments',
                'MachineDocument',
                'ArchivedMachineDocuments',
                'NewMachineDocuments',
                'NewMachineDocumentsCount'
            ]
        }),
        getPaginatedArchivedMachineDocuments: builder.query({
            query: function (machine) { return ({
                url: "MachineDocument/get-paginated-archived",
                method: 'POST',
                body: machine
            }); },
            providesTags: ['ArchivedMachineDocuments']
        })
    }); }
});
export var useCreateMachineDocumentMutation = machineDocumentsApi.useCreateMachineDocumentMutation, useCreateMachineDocumentByGTINMutation = machineDocumentsApi.useCreateMachineDocumentByGTINMutation, useApproveMachineDocumentMutation = machineDocumentsApi.useApproveMachineDocumentMutation, useArchiveMachineDocumentMutation = machineDocumentsApi.useArchiveMachineDocumentMutation, useDeleteArchiveMachineDocumentsMutation = machineDocumentsApi.useDeleteArchiveMachineDocumentsMutation, useGetPaginatedMachineDocumentsQuery = machineDocumentsApi.useGetPaginatedMachineDocumentsQuery, useGetNewPaginatedMachineDocumentsQuery = machineDocumentsApi.useGetNewPaginatedMachineDocumentsQuery, useGetPaginatedArchivedMachineDocumentsQuery = machineDocumentsApi.useGetPaginatedArchivedMachineDocumentsQuery, useLazyGetNewMachineDocumentsCountQuery = machineDocumentsApi.useLazyGetNewMachineDocumentsCountQuery, useDeleteMachineDocumentMutation = machineDocumentsApi.useDeleteMachineDocumentMutation, useLazyGetMachineDocumentQuery = machineDocumentsApi.useLazyGetMachineDocumentQuery, useGetMachineDocumentListByMachineIdMutation = machineDocumentsApi.useGetMachineDocumentListByMachineIdMutation, useUpdateMachineDocumentMutation = machineDocumentsApi.useUpdateMachineDocumentMutation, useLazyGetMachineDocumentListByIdsQuery = machineDocumentsApi.useLazyGetMachineDocumentListByIdsQuery, useRetryDocumentsProcessingMutation = machineDocumentsApi.useRetryDocumentsProcessingMutation, useGetMatchingPublicQuery = machineDocumentsApi.useGetMatchingPublicQuery;
